import React from 'react';
import { Column } from 'rbx';
import styled from 'styled-components';
import { RiEdit2Fill } from 'react-icons/ri';

const Container = styled(Column.Group)`
  border-bottom: 1px solid #b0b0b0;
  background-color: #fbf8f8;
`;

const RemoveWrapper = styled(Column)`
  cursor: pointer;
  color: black;
  padding-top: 18px;
`;

const ItemWithoutVariant = ({
  // setFieldValue,
  // menu_item,
  // selectedLinkIds,
  // item_link_id,
  itemLink,
  onEdit,
}) => (
  <>
    <Container>
      <Column size={6}>{itemLink.name}</Column>
      <Column size={6} style={{ fontSize: '13px' }}>
        <Column.Group>
          <Column size={5} style={{ color: '#00AEEF', fontSize: '16px' }}>
            ${parseFloat(itemLink.menu_item_price || 0).toFixed(2)}
          </Column>
          <RemoveWrapper size={1}>
            <RiEdit2Fill size={18} onClick={onEdit} />
          </RemoveWrapper>
        </Column.Group>
      </Column>
    </Container>
  </>
);

export default ItemWithoutVariant;
